<app-modal [info]="info" (closeModal)="closeModal($event)">
  <ng-template #titleContent>
    <h3 class="modal__title">
      @if (data.candidateCount > 0) {
        {{
          'FOLDERS.REMOVE_FOLDER_MODAL.TITLE_WITH_CANDIDATES'
            | translate
              : {
                  name: data?.name,
                  candidateCount: data.candidateCount,
                  candidateAblative:
                    data.candidateCount | currentNumeric: 'CANDIDATE_ABLATIVE' | translate,
                }
        }}
      } @else {
        {{ 'FOLDERS.REMOVE_FOLDER_MODAL.TITLE' | translate: { name: data?.name } }}
      }
    </h3>
  </ng-template>
</app-modal>
